import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  TableContainer,
  Card,
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
  Grid,
  CardContent,Stack,DialogActions,
  Dialog,
  IconButton,
  InputAdornment,
  DialogContent,
  Box,
  Container
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import * as Yup from "yup";
import Scrollbar from "src/components/Scrollbar";
import { postNewUserData ,uploadImagedData ,getUserDetails,updateUserData,disableUserData ,deleteClient}  from "src/api/addAgent";
import axios from "src/axios";
import { countBy } from "lodash";
import { UpdateDisabled } from "@mui/icons-material";
import Iconify from "src/components/Iconify";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import client from "src/api/clients";
import { Edit, Delete, ToggleOn, ToggleOff } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Page from 'src/components/Page';

const AddAgent = () => {
 
  const [userType, setUserType] = useState('');
  const [agentName, setAgentName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [userNewName, setNewUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //const [image, setImage] = useState(null);

  const [addImage, setAddImage] = useState(null);
  const [addFinalImageURL, setAddFinalImage] = useState('');
  const [editImage, setEditImage] = useState(null);
  const [editFinalImageURL, setEditFinalImage] = useState('');

  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [finalImageURL,setFinalImage] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [visiblePasswordIndex, setVisiblePasswordIndex] = useState(null);

  //Error Messages 
  const [userTypeError,setuserTypeError] = useState('');
  const [agentNameError,setagentNameError] = useState('');
  const [mobileNumberError,setmobileNumberError] = useState('');
  const [userNewNameError,setuserNewNameError] = useState('');
  const [passwordError,setpasswordTypeError] = useState('');
  const [confirmPasswordError,setconfirmPasswordError] = useState('');
  const [imageError,setImageError]=useState('')
  const [userDetails,setUserDetails] = useState([]);

  //Edit Dailog box
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [selectedRowdata,setSelectedRowData] = useState([]);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');

  const [isEdited,setIsEdited]=useState(false)
  const [prvValue,setPrvValue]=useState('')

  const [rowData,setId]=useState([])

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isEditedDisabled,setIsEditedDisabled] = useState(false)


  const [openMessage,setOpenMessage]=useState(false)
  const [openMessageDelete,setOpenMessageDelete]=useState(false)
  const [visibleCount, setVisibleCount] = useState(50);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const [defaultImageBase64, setDefaultImageBase64] = useState('');

  useEffect(() => {
    const convertDefaultImage = async () => {
      try {
        
        const response = await fetch('/static/mock-images/avatars/default.png');
        const blob = await response.blob();
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
        setDefaultImageBase64(base64);
      } catch (error) {
        console.error('Error converting default image:', error);
      }
    };

    convertDefaultImage();
  }, []);



  const [dialogData, setDialogData] = useState({
    userType: '',
    agentName: '',
    mobileNumber: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    image: null,
  });
  

  const [editedData, seteditedData] = useState({
    userType: '',
    agentName: '',
    mobileNumber: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    image: null,
    imageurl:'',
    UserID:''
  });

  useEffect(()=>{
    getUserDetails((response)=>{
      if(response.status === 200){
      // console.log("userData..............", response.data);
        setUserDetails(response.data)
        // seteditedData({
        //   userNewName: '',
        //   password: '',
        //   confirmPassword: '',
        // });
      }
    })
  },[])

  // Add Form Image Upload
useEffect(() => {
  const uploadImage = (imageFile) => {
    const image_file = {
      file_path: `Agent`,
      file: imageFile,
    };
    uploadImagedData(image_file, (response) => {
      if (response.status === 200) {
        setAddFinalImage(response.data.url);
        setIsButtonDisabled(false);
      }
    });
  };

  if (addImage != null) {
    setIsButtonDisabled(true);
    uploadImage(addImage);
  }
}, [addImage]);

// Edit Form Image Upload
useEffect(() => {
  const uploadImage = (imageFile) => {
    const image_file = {
      file_path: `Agent`,
      file: imageFile,
    };
    uploadImagedData(image_file, (response) => {
      if (response.status === 200) {
        setEditFinalImage(response.data.url);
        setIsEditedDisabled(false);
      }
    });
  };

  if (editImage != null) {
    setIsEditedDisabled(true);
    uploadImage(editImage);
  }
}, [editImage]);

  useEffect(() => {
    setImageError('');
    setFinalImage('');

    const uploadImage = (imageFile) => {
     
        // console.log("image file",imageFile);
        const fileName = imageFile.name;
        const image_file = {
            file_path : `Agent`,
            file : imageFile
        };
        uploadImagedData(image_file, (response) => {
            if (response.status === 200) {
                const newImagePath = response.data.url
                setFinalImage(newImagePath)

                setIsButtonDisabled(false);
                setIsDisabled(false)
                setIsEditedDisabled(false)
                
            }
        });
    };

    if (addImage != null) {
        // console.log("Image uploaded", image);
        setIsButtonDisabled(true);
        setIsDisabled(true)
        uploadImage(addImage);
    } else if (editedData.image) {
        // console.log("Edited image uploaded", editedData.image);
        uploadImage(editedData.image);
        //setIsEditedDisabled(true)
    }
}, [addImage, editedData.image]);


  const handleUserTypeChange = (event,val) => {
    // console.log("handel user change ",event.target.value);
   
    if(val==='add'){
      setDialogData({ ...dialogData, userType: event.target.value });
      setUserType(event.target.value)
    }
    else{
      seteditedData({...editedData,userType:event.target.value})
    }
   
  };

  const handleAgentNameChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, agentName: event.target.value });
      setAgentName(event.target.value)
    }
    else{
      seteditedData({...editedData,agentName:event.target.value})
    }
   
  };

  const handleMobileNumberChange = (event,val) => {
        
        let value=event.target.value;
        value=value.replace(/\D/g, '')
        value=value.slice(0,10)

       // console.log(value)
        if(val==="add"){
          setDialogData({ ...dialogData, mobileNumber:value });
          setMobileNumber(value)
        }
        else{
          seteditedData({...editedData,mobileNumber:value})
        }
       
  };
 

  const handleUsername = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, userNewName:event.target.value });
      setNewUsername(event.target.value)
    }
    else{
      setIsEdited(true)
      setPrvValue(editedData.userNewName)
      seteditedData({...editedData,userNewName:event.target.value})
    }
  };

  const handlePasswordChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData,password:event.target.value });
      setPassword(event.target.value)
    }
   else{
    seteditedData({...editedData,password:event.target.value})
   }
  };

  const handleConfirmPasswordChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, confirmPassword: event.target.value });
      setConfirmPassword(event.target.value)
    }
    else{
      seteditedData({...editedData,confirmPassword:event.target.value})
    }
    
  };

  const handleImageChange = (event) => {
   
    //setDialogData({ ...dialogData, image: event.target.files[0] });
    //setImageError('')
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    setIsDisabled(true)
    setAddImage(file)
  };

  const handleEditedImageChange = (event) => {
   
    const file = event.target.files[0];
    if (!file) return;
    //  console.log(event.target.files[0])
    seteditedData({ ...editedData, image: file.name });
    setEditImage(file);
    setIsEditedDisabled(true)
  };

 
  //console.log('Current userNewName:', userNewName);


  const handleSubmit = () => {
   
    // console.log("image",finalImageURL,image);
    let Count = 0;
    setuserTypeError('')
    setagentNameError('')
    setmobileNumberError('')
    setuserNewNameError('')
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setImageError('')
    setFinalImage('')
   


    if(userType === ''){
      setuserTypeError("Please Select UserType",agentName)
      Count = 1;
     
    }
    if(!agentName){
      setagentNameError("Please Enter the Name")
      Count = 1;
    }
    if(!mobileNumber){
      setmobileNumberError("Please Enter the Mobile Number")
      Count = 1;
    }
    if(mobileNumber.length !== 10){
      setmobileNumberError("Please Enter Valid Mobile Number")
      Count = 1;

    }
    if(!userNewName){
      setuserNewNameError("Please Enter the UserName")
      Count = 1;
    }
    if(!password){
      setpasswordTypeError("Please Enter the Password")
      Count = 1;
    }
    if(!confirmPassword){
      setconfirmPasswordError("Please Enter the ConfirmPassword")
      Count = 1;
    }

    if(password != confirmPassword){
      setconfirmPasswordError("Password and ConfirmPassword not Matching")
      Count = 1;
    }

  

    if(addImage === null){
      setImageError('Upload Image')
      Count = 1;
    }

    const insertData = { 
      UserType: userType,
      displayname: agentName,
      ContactNo:mobileNumber,
      Name: userNewName,
      Password: password,
      Image: addFinalImageURL.toString()
    }

    // console.log(userDetails)
    // console.log('Inserted Values', insertData)
   
    const isNameAvail = userDetails.some(item=>item['Name']===insertData.Name)

    if(isNameAvail){
      setuserNewNameError("UserName Already Existed")
      Count=1;
    }

   

 if(Count === 0 ){
    //setUserDetails([])
    setShowSuccessMessage(false); 
    postNewUserData(insertData,(response)=>{
      // console.log(response.data)
      setUserType('');
      setAgentName('');
      setMobileNumber('');
      setNewUsername('');
      setPassword('');
      setConfirmPassword('');
      setAddImage(null);
      setFinalImage('');
       setShowSuccessMessage(true);
      
      // Hide message after 3 seconds
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 3000);

      getUserDetails((response)=>{
        if(response.status === 200){
          // console.log("userData..............", response.data);
          setTimeout(() => {     
              setUserDetails(response.data)      
          }, 300);
        }
      })
    })
 }


  };

  const handleClear = () => {
    setShowSuccessMessage(false); 
    setUserType('');
    setAgentName('');
    setMobileNumber('');
    setNewUsername('');
    setPassword('');
    setConfirmPassword('');
    setAddImage(null);
    setAddFinalImage('');
    setuserTypeError('')
    setagentNameError('')
    setmobileNumberError('')
    setuserNewNameError('')
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setImageError('')

  }

  const handleEdit = (data) => {
    // console.log("data to be edited ",data );
    //Image
    setShowMessage(false)
    let imageUrl=data.Image?data.Image.substring(data.Image.lastIndexOf('/')+1):'';
    seteditedData({
          userType: data.UserType,
          agentName: data.displayname,
          mobileNumber: data.ContactNo,
          userNewName: data.Name,
          password: data.Password,
          confirmPassword: data.Password,
          image: imageUrl?imageUrl:'',
          imageurl:data.Image,
          UserID:data.ID
    })
    setOpenDialogEdit(true);
  };


  const [editNameError,setEditNameError]=useState('')
  const [mobileError,setMobileError]=useState('')
  const [editedPasswordError,setEditedPasswordError]=useState('')
  const [showMessage,setShowMessage]=useState(false)

  const handleUpdated = () => {
    // console.log("editedData ",editedData );
   
    //setShowMessage(false)
    let Count=0
    const updateData = { 
      ID:editedData.UserID,
      UserType: editedData.userType,
      displayname: editedData.agentName,
      ContactNo:editedData.mobileNumber,
      Name: editedData.userNewName,
      Password: editedData.password,
      Image: editFinalImageURL.toString() || editedData.imageurl || ''
    }
   
    // console.log(prvValue)
    if(isEdited){
     
      const isNameAvail = userDetails.find(item=>item['Name']===updateData.Name)// && editedData.UserID!==item['UserID'])
      if(isNameAvail){
        Count=1
        setEditNameError('UserName Already Existed')
      }
    }

    if(updateData.ContactNo){
      if(updateData.ContactNo.length!==10){
        Count=1
        setMobileError('Contact Number must be 10 digits')
      }
    }

    if(editedData.password !== editedData.confirmPassword){
      Count=1
      setEditedPasswordError('Passwords do NOT match')
    }
    // console.log("Updated data ",updateData,Count);
    if(Count===0){
      
      updateUserData(updateData,(response)=>{
       
        // console.log(response)
        if(response.status===200){
          setShowMessage(true)
          setFinalImage('')
          setIsEdited(false)
          setPrvValue('')
          setEditNameError('')
          setMobileError('')
          setEditedPasswordError('')
          getUserDetails((response)=>{
            if(response.status === 200){
              setUserDetails(response.data) 
              setOpenDialogEdit(false)
            }
          })
        }
      })
      setShowMessage(false)
    }

   
  }

  const handleClose = () => {
    setOpenDialogEdit(false);
    setIsEdited(false)
    setPrvValue('')
    setEditNameError('')
    setMobileError('')
    setEditedPasswordError('')
    setShowMessage(false)
    setOpenMessage(false)
    setOpenMessageDelete(false)
    setEditImage(null);
    setEditFinalImage('');
  };




  const handleDisable = (data) => {
    // Add your disable logic here
    // console.log("data...",data);
    setOpenMessage(true)   
    // let Id=data.ID?data.ID:0
    setId(data)
  };

  const handleDelete = (data) => {
    // console.log("data...",data);

    setOpenMessageDelete(true)
    setId(data)
  };

  const disableUser = () =>{
    if(rowData){
      let body={
        ID:rowData.ID,
        Status:rowData.Status === 1 ? 0: 1
      }
      // console.log("body",body)
      disableUserData(body,(response)=>{
        if(response.status===200){
          getUserDetails((response)=>{
            if(response.status === 200){
              setUserDetails(response.data) 
              setOpenMessage(false)
            }
          })
        }
      })
    }
  }

  const deleteUser = () => {
    if(rowData){
      // console.log("body",body)
        deleteClient(rowData.ID, (response) => {
          if (response.status === 200) {
              // reloadClientsData();
              getUserDetails((response)=>{
                if(response.status === 200){
                // console.log("userData..............", response.data);
                  setUserDetails(response.data)
                  setOpenMessageDelete(false)

                  // seteditedData({
                  //   userNewName: '',
                  //   password: '',
                  //   confirmPassword: '',
                  // });
                }
              })
          }
      }); 
  }
}



  // Function to handle the icon click
  const handlePasswordVisibilityToggle = (index) => {
    setVisiblePasswordIndex(visiblePasswordIndex === index ? null : index);
  };

  const handleScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    
    // Load more when 80% scrolled
    if (scrollTop + clientHeight >= scrollHeight * 0.8 && 
        !isLoadingMore && 
        visibleCount < userDetails.length) {
      
      setIsLoadingMore(true);
      
      // Simulate loading delay
      setTimeout(() => {
        setVisibleCount(prev => Math.min(prev + 50, userDetails.length));
        setIsLoadingMore(false);
      }, 300);
    }
  }, [userDetails.length, isLoadingMore, visibleCount]);

  const visibleUsers = userDetails.slice(0, visibleCount);
  console.log('visible users',visibleUsers)

  

  return (
    <Page title="Add Agent/Supervisor">
        <Container maxWidth="xxl" sx={{ p: 0 }}>
          <Card variant="outlined" sx={{ p: 3 }}>
            <CardContent>
            <Typography variant="h4" >Add Agent/Supervisor</Typography>          

              <Grid container spacing={2} alignItems="center">
                <Grid container spacing={2} alignItems="center" marginTop={4}>
                  
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                    <InputLabel id="user-type-label">User Type</InputLabel>
                      <Select
                        labelId="user-type-label"
                        id="user-type"
                        value={userType}
                        onChange={(e)=>handleUserTypeChange(e,'add')}
                        label="User Type"
                        error={userTypeError ? true : false }
                        // helperText={userTypeError}              

                      >
                        {/* <MenuItem value={9}>Deployment</MenuItem> */}
                        <MenuItem value={3}>Supervisor</MenuItem>
                        <MenuItem value={4}>Agent</MenuItem>

                      </Select>
                      {userTypeError && <Typography color="error" variant="body2"  >{userTypeError}</Typography>}

                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <FormControl fullWidth>
                        <TextField
                          id="agent-name"
                          autoComplete="off"
                          variant="outlined"
                          value={agentName}
                          label="Name"
                          onChange={(e)=>handleAgentNameChange(e,"add")}  
                          error={agentNameError  ? true : false }
                        />
                    {agentNameError && <Typography color="error" variant="body2"  >{agentNameError}</Typography>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="mobile-number"
                        autoComplete="off"
                        label="Mobile Number"
                        variant="outlined"
                        value={mobileNumber}
                        onChange={(e)=>handleMobileNumberChange(e,"add")}
                        error={mobileNumberError  ? true : false }
                        inputProps={{
                          pattern: "[0-9]{10}",
                          title: "Mobile number must be 10 digits",
                        }}
                        InputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                      />
                      {mobileNumberError && <Typography color="error" variant="body2"  >{mobileNumberError}</Typography>}
                    </FormControl>
                  </Grid>
                  
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="userdisplayName"
                        autoComplete="off"
                        label="User Name"
                        variant="outlined"
                        value={userNewName}
                        onChange={(e)=>handleUsername(e,"add")}
                        error={userNewNameError  ? true : false }  
                        // inputProps={{
                        //   autocomplete: 'off',
                        //   form: {
                        //     autocomplete: 'off',
                        //   },
                        // }}
                      />
                    {userNewNameError && <Typography color="error" variant="body2"  >{userNewNameError}</Typography>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      {/* <TextField
                        id="userpassword"
                        label="Password"
                        variant="outlined"
                        value={password}
                        onChange={(e)=>handlePasswordChange(e,"add")}
                        error={passwordError  ? true : false }                  
                      /> */}

                        <TextField
                        fullWidth
                        autoComplete="off"
                        name="userpassword"
                        label="Password"
                        onChange={(e)=>handlePasswordChange(e,"add")}
                        value={password}
                        type={showPassword ? 'text' : 'password'}
                        error={passwordError  ? true : false }                  
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                              </IconButton>
                            </InputAdornment>
                          ),
                          autoComplete: 'new-password'
                        }}
                      />
            {passwordError && <Typography color="error" variant="body2"  >{passwordError}</Typography>}


                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <FormControl fullWidth>

                    <TextField
                        fullWidth
                        autoComplete="off"
                        name="userpassword"
                        label="Confirm Password"
                        onChange={(e)=>handleConfirmPasswordChange(e,"add")}
                        value={confirmPassword }
                        type={showConfirmPassword ? 'text' : 'password'}
                        error={confirmPasswordError  ? true : false }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
            {confirmPasswordError && <Typography color="error" variant="body2"  >{confirmPasswordError}</Typography>}             
                    </FormControl>
                  </Grid>

                <Grid item xs={3}>
                    <FormControl fullWidth>
                      <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id="contained-button-file"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <label htmlFor="contained-button-file">
                            <Button
                              color="success"
                              variant="contained"
                              component="span"
                              sx={{ whiteSpace: 'nowrap' }}
                              disabled={isDisabled}
                            >
                              Upload Image
                            </Button>
                          </label>
                                              
                          {/* Progress next to button when uploading */}
                          {isDisabled && (
                            <CircularProgress size={20} />
                          )}
                        </Box>
                        
                        {/* File name below the button row */}
                        {addImage && finalImageURL ? (
                          <Typography variant="caption" sx={{ display: 'block' }}>
                            {addImage.name}
                          </Typography>
                        ) : null}
                        
                        {imageError && (
                          <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
                            {imageError}
                          </Typography>
                        )}
                      </Box>
                    </FormControl>
                  </Grid>

                  <Grid item xs={3} sx={{ height: "100%", marginTop: 2 }}>
                    <Button color="error" variant="contained" onClick={handleClear}>
                      Clear
                    </Button>
                    <Button variant="contained" sx={{ marginLeft: 1 }} onClick={handleSubmit} disabled={isButtonDisabled}>
                      Add
                    </Button>

                    {showSuccessMessage && (
                      <Typography 
                        variant="body2" 
                        color="success.main" 
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          ml: 2
                        }}
                      >
                        <Iconify icon="eva:checkmark-circle-2-fill" width={16} sx={{ mr: 0.5 }} />
                        Data added successfully
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{ marginTop: "1rem" }}
              >
                <Scrollbar>
                  <TableContainer onScroll={handleScroll}
                  >
      
                    <Table stickyHeader>
                      <TableHead sx={{background: '#f3f3f3' }}>
                        <TableRow sx={{background: '#f3f3f3' }}>
                          <TableCell>SNo</TableCell>
                          <TableCell>ID</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>User Type</TableCell>
                          <TableCell>Mobile Number</TableCell>
                          <TableCell>Username</TableCell>
                          <TableCell>Password</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Created On</TableCell>
                          <TableCell>Created By</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* Your table rows go here */}
                        {visibleUsers.map((data, index) => (
                          <TableRow key={index}
                          // style={{ backgroundColor: data.Status === 0 ? '#F5B7B1' : 'inherit' }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{data.ID}</TableCell>
                            <TableCell>{data.displayname}</TableCell>
                            <TableCell>{data.UserType === 4 ? "Agent" :data.UserType === 3 ? "Supervisor" : data.UserType ===  9 ? 'Deployment':'' }</TableCell>
                            <TableCell>{data.ContactNo}</TableCell>
                            <TableCell>{data.Name}</TableCell>

                              <TableCell>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="body2" style={{ marginRight: 8 }}>
                              {visiblePasswordIndex === index ? data.Password : '••••••••'}
                            </Typography>
                            <IconButton
                              onClick={() => handlePasswordVisibilityToggle(index)}
                              edge="end"
                            >
                              {visiblePasswordIndex === index ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </div>
                        </TableCell>
                            <TableCell>
                              {/* <img
                                key={data.Image}
                                src={data.Image ? data.Image : '/static/mock-images/avatars/default.png'}
                                alt="User Image"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                }}
                              
                              /> */}
                            <img
                              key={data.Image || 'default'}
                              src={data.Image ? data.Image : '/static/mock-images/avatars/default.png'}
                              alt="User Image"
                              style={{
                                width: "100px",
                                height: "100px",
                              }}
                              onError={(e) => {
                                e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y0ZjRmNCIvPjx0ZXh0IHg9IjUwIiB5PSI1MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+Tm8gSW1hZ2U8L3RleHQ+PC9zdmc+';
                                e.target.onerror = null;
                              }}
                            />
                            </TableCell>
                            <TableCell>{data.CreatedOn}</TableCell>
                            <TableCell>{data.CreatedBy}</TableCell>                     
                            <TableCell>
                              <Grid container spacing={1}>
                                <Grid item>
                                  <Tooltip title="Edit">
                                    <IconButton
                                      disabled={data.Status === 0}
                                      sx={{
                                        backgroundColor: data.Status === 0 ? "gray" : "primary.main",
                                        color: "white",
                                        "&:hover": { backgroundColor: "primary.dark" },
                                        p: 0.5,
                                      }}
                                      onClick={() => handleEdit(data)}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>

                                <Grid item>
                                  <Tooltip title={data.Status === 1 ? "Disable" : "Enable"}>
                                    <IconButton
                                      sx={{
                                        backgroundColor: data.Status === 1 ? "red" : "green",
                                        color: "white",
                                        "&:hover": { backgroundColor: data.Status === 1 ? "darkred" : "darkgreen" },
                                        p: 0.5,
                                      }}
                                      onClick={() => handleDisable(data)}
                                    >
                                      {data.Status === 1 ? <ToggleOff fontSize="small" /> : <ToggleOn fontSize="small" />}
                                    </IconButton>
                                  </Tooltip>
                                </Grid>

                                <Grid item>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      sx={{
                                        backgroundColor: "red",
                                        color: "white",
                                        "&:hover": { backgroundColor: "darkred" },
                                        p: 0.5,
                                      }}
                                      onClick={() => handleDelete(data)}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </Grid>

              <Dialog open={openDialogEdit} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
              <DialogContent>
            
              <Grid container spacing={2} alignItems="center">
                  <Grid container spacing={2} alignItems="center" marginTop={4}>
                    
                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <InputLabel id="user-type-label">User Type  </InputLabel>
                        <Select
                          labelId="user-type-label"
                          id="user-type"
                          value={editedData.userType}
                          onChange={(e)=>handleUserTypeChange(e,'edit')}
                          label="User Type"
                          disabled={editedData.userType === 9}
                        >
                        {editedData.userType !== 3 && editedData.userType !== 4 && (
                              <MenuItem value={9}>Deployment</MenuItem>
                            )}
                          <MenuItem value={3}>Supervisor</MenuItem>
                          <MenuItem value={4}>Agent</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>



                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="agent-name"
                          variant="outlined"
                          value={editedData.agentName}
                          label="Name"
                          onChange={(e)=>handleAgentNameChange(e,"edit")}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="mobile-number"
                          label="Mobile Number"
                          variant="outlined"
                          value={editedData.mobileNumber}
                          onChange={(e)=>handleMobileNumberChange(e,"edit")}
                          error={mobileError ? true : false}
                          // inputProps={{
                          //   pattern: "[0-9]{10}",
                          //   title: "Mobile number must be 10 digits",
                          // }}
                          // InputProps={{
                          //   inputMode: "numeric",
                          //   pattern: "[0-9]*",
                          // }}
                        />
                    {mobileError && <Typography color="error" variant="body2"  >{mobileError}</Typography>}

                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="userdisplayName"
                          label="User Name"
                          variant="outlined"
                          value={editedData.userNewName}
                          onChange={(e)=>handleUsername(e,"edit")}
                          error={editNameError ? true : false}
                        />
                        {editNameError && <Typography color="error" variant="body2"  >{editNameError}</Typography>}

                      </FormControl>
                      {/* {editNameError && (<Typography color='error' fontSize={12}>{editNameError}</Typography>)} */}
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="userpassword"
                          label="Password"
                          variant="outlined"
                          value={editedData.password}
                          onChange={(e)=>handlePasswordChange(e,"edit")}
                          error={editedPasswordError ? true : false}
                        />
                    {editedPasswordError && <Typography color="error" variant="body2"  >{editedPasswordError}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                      <TextField
                        id="confirmPassword"
                        label="Confirm Password"
                        variant="outlined"
                        value={editedData.confirmPassword}
                        onChange={(e) => handleConfirmPasswordChange(e, "edit")}
                        error={editedPasswordError ? true : false}
                      />
                    {editedPasswordError && <Typography color="error" variant="body2"  >{editedPasswordError}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <input
                          accept="image/*"
                          style={{ display: "none" }}
                          id="contained-button-file-two"
                          type="file"
                          onChange={handleEditedImageChange}
                        />
                          <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                              <label htmlFor="contained-button-file-two">
                                <Button
                                  color="success"
                                  variant="contained"
                                  component="span"
                                  sx={{ whiteSpace: 'nowrap' }}
                                  disabled={isEditedDisabled}
                                >
                                  Upload Image
                                </Button>
                              </label>
                                                  
                              {/* Progress next to button when uploading */}
                              {isEditedDisabled && (
                                <CircularProgress size={20} />
                              )}
                            </Box>
                            
                            {/* File name below the button row */}
                            {editedData.image ? (
                              <Typography variant="caption" sx={{ display: 'block' }}>
                                {editedData.image}
                              </Typography>
                            ) : null}
                            
                          
                          </Box>
                      </FormControl>
                    </Grid>

                  

                    <Grid item xs={12} sx={{ height: "100%",textAlign:'right'}}>
                      <Button color="error" variant="contained" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="contained" sx={{ marginLeft: 1 }} onClick={handleUpdated}>
                        Save
                      </Button>
                      
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} alignItems="center" marginTop={4} marginLeft={1}> 
                      {showMessage && (<Typography color='#3f51b5'>Details Updated Successfully!!</Typography>)}
                  </Grid>
                </Grid>
                


              </DialogContent>
            </Dialog>

            {/* <Dialog
              open={openMessage}
              onClose={handleClose}
              sx={{
                '& .MuiDialog-paper': {
                  backgroundColor: '#f5f5f5',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderRadius: '10px',
                },
                '& .MuiTypography-root': {
                  fontWeight: 'bold',
                  marginBottom: '20px',
                }
              }}
            >
              <Typography>Do You Want to Disable User?</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid container spacing={2} paddingTop={2} gap={2}>
                  <Button onClick={disableUser} variant="contained" color="primary">Ok</Button>
                  <Button onClick={handleClose} variant="outlined" color="error">Close</Button>
                </Grid>
              </Box>
            </Dialog> */}

            <Dialog 
                  open={openMessage}
                  onClose={handleClose}>
                  <DialogContent>
                  <Stack
                  //  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ maxWidth: 350, textAlign: "center" }}
                  >
                  <Iconify
                    icon={"eva:alert-triangle-outline"}
                    sx={{ fontSize: 92, color: "#ffb2a3" }}
                  />
                  <Typography sx={{ color: "gray" }} variant="h5">
                    {" "}
                    Are you sure you want to {rowData.Status === 1 ? "Disable" : "Enable"}  the user :  {rowData.displayname}?
                  </Typography>
                  </Stack>
                  </DialogContent>
                  <DialogActions>
                  <Button
                  variant="contained"
                  onClick={handleClose}
                  color="error"
                  >
                  No
                  </Button>
                  <Button variant="contained"  onClick={disableUser}>
                  Yes
                  </Button>
                  </DialogActions>
            </Dialog>



            <Dialog 
                  open={openMessageDelete}
                  onClose={handleClose}>
                  <DialogContent>
                  <Stack
                  //  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ maxWidth: 350, textAlign: "center" }}
                  >
                  <Iconify
                    icon={"eva:trash-2-outline"}
                    sx={{ fontSize: 92, color: "#ff4d4d" }}
                  />
                  <Typography sx={{ color: "gray" }} variant="h5">
                    {" "}
                    Are you sure you want to Delete the user :  {rowData.displayname}?
                  </Typography>
                  </Stack>
                  </DialogContent>
                  <DialogActions>
                  <Button
                  variant="contained"
                  onClick={handleClose}
                  color="error"
                  >
                  No
                  </Button>
                  <Button variant="contained"  onClick={deleteUser}>
                  Yes
                  </Button>
                  </DialogActions>
            </Dialog>
            </CardContent>
          </Card>
        </Container>
    </Page>
  );
};

export default AddAgent;
